import React from "react";
import PropTypes from "prop-types";
import {MessageMetadataView} from "./MessageMetadataView";
import moment from "moment";
import SafeHtmlContainer from "../../../../helpers/SafeHtmlContainer";
import {FaSolidIcon} from "../../../FontAwesomeIcons";
import {NativeBrowserAnchorHOC} from "../../../../hoc/NativeBrowserAnchorHOC";
import {markdownToHTML} from "../../../../helpers/Markdown";

export function TextMessage({isMine, isLast, messageData, getMediaContentUrlAPI, ...props}) {
    const sendTime = moment(messageData.data_creazione).format('HH:mm');

    function urlify(text) {
        var urlRegex = /\s?(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>';
        });
    }

    return (
        <React.Fragment>
            <NativeBrowserAnchorHOC>
                <SafeHtmlContainer html={markdownToHTML(urlify(messageData.contenuto))}/>
            </NativeBrowserAnchorHOC>
            {props.widget}
            {
                !!messageData.metadata &&
                <MessageMetadataView
                    metadata={messageData.metadata}
                    isMine={isMine}
                    idMessaggio={messageData.id_messaggio}
                />
            }
            <div className={"metadata"}>
                {sendTime}&nbsp;
                {
                    isMine &&
                    <FaSolidIcon name={messageData.letto === '1' ? 'check-double' : 'check'}/>
                }
            </div>
        </React.Fragment>
    )
}

TextMessage.propTypes = {
    isMine: PropTypes.bool,
    messageData: PropTypes.object.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
    widget: PropTypes.element,
}
